export default {"src":"/_next/static/media/error-page-img.1b4efa5f.svg","height":369,"width":357,"blurWidth":0,"blurHeight":0};